import axiosInstance from '../api/axios';


// Function to get all students
export const getAllAnnouncements = async () => {
    try {
        const response = await axiosInstance.get('/announcements');
        return response.data;
    } catch (error) {
        console.error('Error fetching announcements:', error);
        throw error;
    }
};